/**
 * Google Material Symbols Rounded helper (master-context.md → "Home UI
 * specification"). The font is loaded from index.html with an `icon_names`
 * subset — add any new icon name there too, in alphabetical order.
 */

/** `<span class="ms">name</span>`; `fill` renders the filled variant. */
export function icon(name: string, opts: { fill?: boolean; cls?: string } = {}): string {
  const cls = ['ms', opts.fill ? 'ms-fill' : '', opts.cls ?? ''].filter(Boolean).join(' ');
  return `<span class="${cls}" aria-hidden="true">${name}</span>`;
}
